export const GlobalDadosApp = {
  IdLoja: 0,
  Empresa: {
    Area: {},
    Config: {},
    Empresa: {},
    Mult: [],
  },
  Cardapio: {
    Adicionais: [],
    Categorias: [],
    Combos: [],
    Obrigatorios: [],
    Produtos: [],
    retorno: {},
  },
  DiaSemana: '',
  FormasPagamento: [],
  TabelaTaxaKm: [],
  TipoApp: 'DELIVERY',
  Mesa: 0,
  Qs: {
    Body: '',
    Destino: 'SRVCX',
    Idloja: '',
    Origem: 'USUARIO',
    SetorCardapio: '',
    SetorTrabalho: '',
    Solicitacao: '0',
    mesa: '',
    posicao: '',
  },
};

export const GlobalStatusLoja = {
  StatusLoja: true,
  StatusText: 'Loja Aberta',
  NextValidDay: new Date(),
  //NextValidHour: new Date(),
};

export const GlobalSacola = {
  TotalItens: 0,
  ValorTotal: 0,
};

export const GlobalUser = {
  id: 0,
  idloja: 0,
  nome: '',
  sobrenome: '',
  nome_completo: '',
  email: '',
  senha: '',
  telefone_ddd: '',
  telefone: '',
  empresa_fantasia: '',
  empresa_razao: '',
  data_aniversario: '2011-01-01',
  cpf: '',
  sexo: 'Masculino',
  geolocation: {
    IPv4: '',
    city: null,
    country_code: '',
    country_name: '',
    latitude: 0,
    longitude: 0,
    postal: null,
    state: null,
  },
};

export const GlobalEnderecos = [
  // {
  //   id: 0,
  //   idloja: 0,
  //   cep: '',
  //   codigo_cliente: 0,
  //   endereco: '',
  //   endereco_bairro: '',
  //   endereco_cidade: '',
  //   endereco_estado: '',
  //   endereco_numero: '',
  //   latitude: 0,
  //   longitude: 0,
  //   titulo: '',
  //   ativo: 0,
  //   distancia: 0,
  //   taxa: 0,
  // },
];

export const GlobalOpenPedidos = 'none';
